import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const chequeColdefs = [
    {
        field: "id",
        headerName: "ID",
        minWidth: window.innerWidth * 0.06,
        flex: 0.2,
        filter: true,
    },
    {
        field: "chequeBookNo",
        headerName: "Cheque book no",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "isCancel",
        headerName: "Is cancle",
        minWidth: window.innerWidth * 0.06,
        flex: 0.5,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
];

export const ChequeBookMasterPopup = (props) => {
    return (
        <ModalBasic
            id="cityMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Bank details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-3'>
                        <label>Account name</label>
                        <MultiSelectDropdown
                            drpIdentity="Country"
                            options={props.chequeObject.bankList}
                            value={props.chequeObject.idBank ? props.chequeObject.bankList.find(x => x.value === props.chequeObject.idBank) : 0}
                            onChange={(selected) =>
                                props.handleChangeFroDropdown(selected, "idBank")
                            }
                            className={props.validState?.error?.idBank !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Cheque book date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.chequeObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Cheque book series</label>
                        <div className='inputGrp-inner flex items-center gap-2.5'>
                            <TextInput type='number'
                                id='chequeBookSeriesFrom' name='chequeBookSeriesFrom'
                                value={props.chequeObject.chequeBookSeriesFrom}
                                handleChange={(event) => props.handleChange(event, 'chequeBookSeriesFrom')}
                                className={`!w-[150px] ${props.validStateForChequeSeries?.error?.chequeBookSeriesFrom !== undefined ? "error" : ""}`}
                            />
                            <span>to</span>
                            <TextInput type='number'
                                id='chequeBookSeriesTo' name='chequeBookSeriesTo'
                                value={props.chequeObject.chequeBookSeriesTo}
                                handleChange={(event) => props.handleChange(event, 'chequeBookSeriesTo')}
                                className={`!w-[150px] ${props.validStateForChequeSeries?.error?.chequeBookSeriesTo !== undefined ? "error" : ""}`}
                            />
                            {props.chequeObject.idChequeBookMaster > 0 ?
                                null :
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.generateAutoChequeNO()} >Auto Cheque No</button>
                            }
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.addItem()} >Add</button>
                    </div>
                </div>

                <div className="cheque-table h-[35vh] pb-[8px]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.chequeObject.itemList}
                            columnDefs={chequeColdefs}
                            onRowDoubleClicked={props.handleCellClickItemList}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    {props.chequeObject.idChequeBookMaster > 0 ?
                        <button className="update-btn btns" onClick={() => props.submit()}>Update</button>
                        :
                        <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    }
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}